import { render } from "./AgroBreadcrumbs.vue?vue&type=template&id=1c83da7e&ts=true"
import script from "./AgroBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AgroBreadcrumbs.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__